import { render, staticRenderFns } from "./ShipTracking.vue?vue&type=template&id=d38655ae&scoped=true"
import script from "./ShipTracking.vue?vue&type=script&lang=ts"
export * from "./ShipTracking.vue?vue&type=script&lang=ts"
import style0 from "./ShipTracking.vue?vue&type=style&index=0&id=d38655ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38655ae",
  null
  
)

export default component.exports